import { ChevronRight } from 'lucide-react'
import ExecutionList from '@/frontend/features/Fde/investigations/ExecutionList'
import { investigationDate } from '@/frontend/features/Fde/investigations/format'
import type { InvestigationLabels, InvestigationRun } from '@/frontend/features/Fde/investigations/types'

export default function InvestigationActivity({ run, copy }: { run: InvestigationRun; copy: InvestigationLabels }) {
  return <details className="group/activity min-w-0 border-t border-border pt-4">
    <summary className="flex cursor-pointer list-none items-center gap-1.5 rounded-sm text-xs font-medium text-muted-foreground hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
      <ChevronRight className="size-3.5 transition-transform group-open/activity:rotate-90" aria-hidden />{copy.activity}
    </summary>
    <div className="mt-5 grid min-w-0 gap-6">
      {run.events.length === 0 ? <p className="text-xs text-muted-foreground">{copy.no_activity}</p> : <ol className="grid gap-4 border-l border-border pl-4">
        {run.events.map((event, index) => <li key={`${event.at}:${index}`} className="grid gap-1">
          <time dateTime={event.at} className="text-[11px] text-muted-foreground">{investigationDate(event.at)}</time>
          <p className="text-sm leading-relaxed">{event.message}</p>
        </li>)}
      </ol>}
      <section className="grid min-w-0 gap-3">
        <h3 className="text-xs font-medium text-muted-foreground">{copy.executions} <span className="tabular-nums">({run.executions.length})</span></h3>
        <ExecutionList executions={run.executions} copy={copy} />
      </section>
    </div>
  </details>
}
